import Campo from "./Campo";
import { formatarData } from "../../../utils/solicitacoes/formatters";

/**
 * Dados de uma GDM da base (DadosGdm no backend) — usado no formulário da Renovação de GDM (GDMs
 * do cliente) e no detalhe da solicitação (cópia da GDM renovada). Campos vazios não aparecem.
 */
export default function GdmDadosCampos({ gdm, className = "grid grid-cols-2 md:grid-cols-4 gap-4 text-sm" }) {
    if (!gdm) return null;
    return (
        <div className={className}>
            <Campo label="GDM Status" valor={gdm.gdmStatus} />
            <Campo label="Status PDV" valor={gdm.statusPdv} />
            <Campo label="Rota" valor={gdm.rota} />
            <Campo label="Canal" valor={gdm.canal} />
            <Campo label="Cidade" valor={gdm.cidade} />
            <Campo label="Data de aquisição" valor={gdm.dataAquisicao ? formatarData(gdm.dataAquisicao) : null} />
            <Campo label="Número de série" valor={gdm.numeroSerie} />
            <Campo label="Contrato (CEV)" valor={gdm.numeroContratoCev} />
            <Campo label="GDM Ativo" valor={gdm.gdmAtivo} />
            <Campo label="GDM Código" valor={gdm.gdmCodigo} />
            <div className="col-span-2">
                <Campo label="GDM Descrição" valor={gdm.gdmDescricao} />
            </div>
            <Campo label="Logomarca" valor={gdm.logomarca} />
            <Campo label="Modelo de fabricação" valor={gdm.modeloFabricacao} />
            <Campo label="Código Produto SAP" valor={gdm.codigoProdutoSap} />
        </div>
    );
}
